exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dropdown{list-style-type:none}.dropdown .dropdown-toggle{cursor:pointer}", ""]);

// exports
